import { render, staticRenderFns } from "./menuUp.vue?vue&type=template&id=234dc2ce&"
import script from "./menuUp.vue?vue&type=script&lang=js&"
export * from "./menuUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports